module.exports = __webpack_public_path__ + "static/assets/80e719cefc8ebc0af12101978758f708.png";